import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { IconEdit, IconSuccess, PrimaryButton, InlineTextButton } from '../../components';
import css from './StripeConnectAccountStatusBox.module.css';

const STATUS_VERIFICATION_NEEDED = 'verificationNeeded';
const STATUS_VERIFICATION_SUCCESS = 'verificationSuccess';
const STATUS_VERIFICATION_ERROR = 'verificationError';

const renderMissingRequirements = missingRequirementTypes => {
  const visibleRequirementTypes = [...new Set(missingRequirementTypes || [])].filter(Boolean);

  return visibleRequirementTypes.length > 0 ? (
    <div className={css.missingRequirements}>
      <div className={css.missingRequirementsTitle}>
        <FormattedMessage id="StripeConnectAccountStatusBox.missingRequirementsTitle" />
      </div>
      <ul className={css.missingRequirementsList}>
        {visibleRequirementTypes.map(requirementType => (
          <li key={requirementType}>
            <FormattedMessage
              id={`StripeConnectAccountStatusBox.missingRequirement.${requirementType}`}
            />
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

const StripeConnectAccountStatusBox = props => {
  const {
    type,
    onGetStripeConnectAccountLink,
    inProgress,
    disabled,
    buttonTitle,
    missingRequirementTypes = [],
    title,
  } = props;
  const hasExternalAccountRequirement = missingRequirementTypes.includes('externalAccount');
  const verificationNeededTitleId = hasExternalAccountRequirement
    ? 'StripeConnectAccountStatusBox.payoutSetupNeededTitle'
    : 'StripeConnectAccountStatusBox.verificationNeededTitle';
  const verificationNeededTextId = hasExternalAccountRequirement
    ? 'StripeConnectAccountStatusBox.verificationNeededExternalAccountText'
    : 'StripeConnectAccountStatusBox.verificationNeededText';
  const resolvedButtonTitle = buttonTitle || title;

  if (type === STATUS_VERIFICATION_NEEDED) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationNeededBox)}>
        <div className={css.verificiationBoxTextWrapper}>
          <div className={css.verificationBoxTitle}>
            <FormattedMessage id={verificationNeededTitleId} />
          </div>
          <div className={css.verificationBoxText}>
            <FormattedMessage id={verificationNeededTextId} />
          </div>
          {renderMissingRequirements(missingRequirementTypes)}
        </div>

        <PrimaryButton
          className={css.getVerifiedButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          onClick={onGetStripeConnectAccountLink}
          title={resolvedButtonTitle}
        >
          <FormattedMessage id="StripeConnectAccountStatusBox.getVerifiedButton" />
        </PrimaryButton>
      </div>
    );
  } else if (type === STATUS_VERIFICATION_SUCCESS) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationSuccessBox)}>
        <div
          className={classNames(
            css.verificiationBoxTextWrapper,
            css.verificationBoxSuccessTextWrapper
          )}
        >
          <div className={css.verificationBoxTitle}>
            <IconSuccess className={css.icon} />
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationSuccessTitle" />
          </div>
        </div>

        <InlineTextButton
          className={css.editVerificationButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          onClick={onGetStripeConnectAccountLink}
          title={resolvedButtonTitle}
        >
          <IconEdit className={css.icon} pencilClassName={css.iconEditPencil} />
          <FormattedMessage id="StripeConnectAccountStatusBox.editAccountButton" />
        </InlineTextButton>
      </div>
    );
  } else if (type === STATUS_VERIFICATION_ERROR) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationErrorBox)}>
        <div className={css.verificiationBoxTextWrapper}>
          <div className={css.verificationBoxTitle}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationFailedTitle" />
          </div>
          <div className={css.verificationBoxText}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationFailedText" />
          </div>
          {renderMissingRequirements(missingRequirementTypes)}
        </div>

        <PrimaryButton
          className={css.getVerifiedButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          title={resolvedButtonTitle}
          onClick={onGetStripeConnectAccountLink}
        >
          <FormattedMessage id="StripeConnectAccountStatusBox.getVerifiedButton" />
        </PrimaryButton>
      </div>
    );
  } else {
    throw new Error(`Unknown type ${type} for StripeConnectAccountStatusBox`);
  }
};

export default StripeConnectAccountStatusBox;
